<template>
    <div class="m-portlet m-portlet--head-sm" v-loading="loading">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <div class="m-portlet__head-text">
                        <el-select v-model="filter.section_id" placeholder="请选择校区" @change="handleShow()">
                            <el-option
                                    v-for="item in sections"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>

                        <el-select v-model="filter.grade_id" multiple placeholder="请选择年级" @change="handleShow()">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>

                        <small>日期：</small>
                        <el-date-picker
                                v-model="filter.date"
                                type="date"
                                :clearable="false"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                @change="handleShow()">
                        </el-date-picker>

                        <el-switch v-model="showStudent"
                                   @change="showStudentFuc"
                                   active-text="显示学生"
                                   size="small">
                        </el-switch>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-portlet__body" v-if="V4Judge">
            <DailyTable ref="V4Table"
                        @handleMouseDown="handleMousedown"
                        @drop="drop"
                        @allowDrop="allowDrop"
                        @handleCellClick="handleCellClick"
                        v-show="V4Show"></DailyTable>
        </div>
        <el-dialog
                title="创建特殊"
                :visible.sync="dialogVisible"
                width="400px"
                :before-close="handleClose"
                append-to-body
        >
            <ChooseSpecialClass v-if="dialogVisible"></ChooseSpecialClass>
        </el-dialog>

    </div>

</template>

<script>
    import index from '../../../../TimeTable/Daily/Index'
    import ChooseSpecialClass from './Dialog_CreateSpecialClass'
    export default {
        name: "OperationDaily",
        data() {
            return {
                path: "/timeTable/day",
                loading: true,
                V4Judge: false,
                V4Show: false,
                showStudent: false,
                dialogVisible:false,
                borderColor: '#ededed',
                fillStyle: "#555",
                V4titleW: 100 * window.devicePixelRatio,
                V4titleH: 50 * window.devicePixelRatio,
                V4leftTimeW: 120 * window.devicePixelRatio,
                V4rectW: 100 * window.devicePixelRatio,
                V4rectH: 60 * window.devicePixelRatio,
                V4ratio: window.devicePixelRatio,
                startPoint: {
                    x: 1,
                    y: 1
                },
                //subscribe
                grades: {},
                sections: {},
                classes: {},
                timeData: {},
                basisTime: {},
                subjects: {},
                teachers: {},
                class_student: {},

                tempLength: 0,

                classrooms: {},
                scroll: {
                    left: 0,
                    top: 0
                },
                filter: {
                    semester_id: this.$store.state.config.nowSemester.id,
                    section_id: this.$store.state.config.section.id,
                    grade_id: [],
                    date: ''
                },
                dialogData:{
                    student_id:'',
                    subject_id:'',
                    teacher_id:'',
                    subject_name:'',
                    teacher_name:'',
                    classHeight:'',
                    start_time:'',
                    classPlanStudent_id:'',
                    time:0,
                    date:'',
                    width:600,
                    status:''
                },
                classx: '',
                classForm: {},

                //每日课表组件
                ops: {
                    rail: {
                        size: '3px',
                        gutterOfSide: '5px'
                    },
                    bar: {
                        keepShow: true,
                        background: 'rgba(144, 147, 153, 0.3)'
                    }
                },
                ctx: '',
                timeCtx: '',
                V4cell: {
                    selectable: false,
                    subject_id: '',
                    teacher_id: '',
                    startSort: 0,
                },

                scrollLeft: 0,
                scrollTop: 0,
                startTime: 8,
                endTime: 23,
                type: 'dayTimeTable_studentPeriod',

                studentCarts: {},
                V4Table:'',
            }
        },
        components: {
            'DailyTable': index,
            'ChooseSpecialClass': ChooseSpecialClass,
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            list() {
                let length = 0;
                for (let subject_id in this.subjects) {
                    if (this.teachers[subject_id]) {
                        length += Object.keys(this.teachers[subject_id]).length
                    }
                }
                return length;
            },
            row() {
                let length = 0;
                for (const key in this.basisTime) {
                    if (key > this.startTime && key < this.endTime) {
                        length++;
                    }
                }
                return length
            },
            orderStudentCarts: function () {
                return this._.orderBy(this.studentCarts, 'sortBy', 'asc');
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.handleShow()
            })
        },
        created() {
            this.dialogData.classPlanStudent_id=this.$store.state.modal.data.classPlanStudent_id;
            this.dialogData.student_id=this.$store.state.modal.data.student_id;
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.path, this.handleData);
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'show_specialDate':
                        this.sections = data.sections;
                        this.grades = data.grades;
                        this.timeData = data.timeData;
                        this.subjects = data.subjects;
                        this.teachers = data.teachers;
                        this.classes = data.classes;
                        this.basisTime = data.basisTime;
                        this.classrooms = data.classrooms;
                        this.class_student = data.class_student;
                        this.filter.date = data.date;
                        this.tempLength = data.tempLength;
                        this.V4Show = true;
                        this.loading = false;
                        this.V4Judge = true;
                        this.V4Table = this.$refs.V4Table;
                        setTimeout(()=>{
                            if(this.V4Judge){
                                this.$refs.V4Table.initCanvas()

                            }
                        },100)
                        break;
                    case 'class_update':
                        if (this.filter.date == data.old_date) {
                            if (this.classes[data.old_teacher_id]) {
                                for (let key in this.classes[data.old_teacher_id]) {
                                    if (this.classes[data.old_teacher_id][key].class_plan_id == data.classPlan_id) {
                                        this.classes[data.old_teacher_id].splice(key, 1)
                                        this.V4Table.initCanvas()
                                        break;
                                    }
                                }
                            }
                        }
                        if (this.filter.date == data.classPlan.date) {
                            if (this.classes[data.classPlan.teacher_id]) {
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);

                            } else {
                                this.classes[data.classPlan.teacher_id] = [data.classPlan]
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.V4Table.initCanvas()
                        }
                        break;
                    case 'store_specialClass':
                        if (this.filter.date == data.classPlan.date) {
                            if (this.classes[data.classPlan.teacher_id]) {
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);
                            } else {
                                this.classes[data.classPlan.teacher_id] = [data.classPlan]
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.V4Table.initCanvas()
                        }
                        this.dialogVisible=false;
                        break;
                    case 'drop_class':
                        for (let key in data.old_timeTable ) {
                            if(this.filter.date==data.old_timeTable[key].date && this.filter.section_id==data.old_timeTable[key].section_id){
                                if(this.classes[data.old_timeTable[key].teacher_id]){
                                    for(let key1 in this.classes[data.old_timeTable[key].teacher_id]){
                                        if(this.classes[data.old_timeTable[key].teacher_id][key1].class_plan_id==data.old_timeTable[key].class_plan_id){
                                            this.classes[data.old_timeTable[key].teacher_id].splice(key1,1)
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        for (let key2 in data.new_timeTable ) {
                            if (this.filter.date ==data.new_timeTable[key2].date && this.filter.section_id ==data.new_timeTable[key2].section_id) {
                                if (this.classes[data.new_timeTable[key2].teacher_id]) {
                                    this.classes[data.new_timeTable[key2].teacher_id].push(data.new_timeTable[key2]);
                                } else {
                                    this.classes[data.new_timeTable[key2].teacher_id] = [data.new_timeTable[key2]]
                                }

                            }
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                    case 'create_class':
                        for (let key in data.timeTable_days ) {
                            if (this.filter.date ==data.timeTable_days[key].date && this.filter.section_id ==data.timeTable_days[key].section_id) {
                                if (this.classes[data.timeTable_days[key].teacher_id]) {
                                    this.classes[data.timeTable_days[key].teacher_id].push(data.timeTable_days[key]);
                                } else {
                                    this.classes[data.timeTable_days[key].teacher_id] = [data.timeTable_days[key]]
                                }
                            }
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                }
            },
            handleStudentData(event, data) {
                switch (event) {
                    case 'get_studentClassPlan_to_otherClassPlan':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.V4Table.initCanvas()
                        break;
                    case 'get_studentClassPlan_to_newClassPlan':
                        if (this.filter.date == data.classPlan.date) {
                            if (this.classes[data.classPlan.teacher_id]) {
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);
                            } else {
                                this.classes[data.classPlan.teacher_id] = [data.classPlan]
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.V4Table.initCanvas()
                        }
                        this.dialogVisible=false;
                        break;

                }
            },
            //开画
            drawLine(ctx, start = [0, 0], end = [0, 0], lineDash = []) {
                let x = this.startPoint.x;
                let y = this.startPoint.y;
                ctx.beginPath();
                ctx.setLineDash(lineDash);
                ctx.moveTo(start[0] + x, start[1] + y);
                ctx.lineTo(end[0] + x, end[1] + y);
                ctx.stroke()
            },
            getFontStyle(size, lineHeight) {
                return 'normal ' + size * this.V4ratio + 'px/' + lineHeight * this.V4ratio + 'px  Microsoft YaHei';
            },
            handleShow() {
                this.loading = true;
                this.$wApi.send(this.path, 'show_specialDate', {'classPlanStudent_id': this.$store.state.modal.data.classPlanStudent_id, 'section_id': this.filter.section_id,'date':this.filter.date});
                this.$wApi.addListen('/student/' + this.$parentInfo.student.id, this.handleStudentData);
                this.V4Show = false;
            },
            //点击
            handleCellClick(evt) {
                this.V4Table=this.$refs.V4Table;
                if (this.V4cell.selectable) {
                    if (this.classes[this.V4cell.teacher_id]) {
                        for (var key in this.classes[this.V4cell.teacher_id]) {
                            if (this.classes[this.V4cell.teacher_id][key].start_sort - this.startTime == this.V4cell.startSort) {
                                let changeClass=this.classes[this.V4cell.teacher_id][key]
                                if(this.classes[this.V4cell.teacher_id][key].section_id==this.filter.section_id) {
                                    //调入该班
                                    this.$confirm('是否调入该班?', '提示', {
                                        StartReturn: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        this.$wApi.send('/student/' + this.$parentInfo.student.id, 'get_studentClassPlan_to_otherClassPlan', {
                                            'classPlanStudent_id': this.$store.state.modal.data.classPlanStudent_id,
                                            'classPlan_id': changeClass.class_plan_id,
                                            'status': this.$store.state.modal.data.status,
                                            'student_id': this.$store.state.modal.data.student_id,
                                            'reason': this.$store.state.modal.data.reason
                                        });
                                    }).catch(() => {
                                        this.$message({
                                            type: 'info',
                                            message: '已取消'
                                        });
                                    });
                                }
                            }
                        }
                    }
                }else{
                    this.dialogData={
                        student_id:this.$store.state.modal.data.student_id,
                        subject_id:this.V4cell.subject_id,
                        teacher_id:this.V4cell.teacher_id,
                        subject_name:this.subjects[this.V4cell.subject_id].name,
                        teacher_name:this.teachers[this.V4cell.subject_id][this.V4cell.teacher_id].name,
                        classHeight:this.$refs.V4Table.cell.classHeight,
                        time:this.$refs.V4Table.cell.classHeight*60,
                        start_time:evt.start_time,
                        date:this.filter.date,
                        status: this.$store.state.modal.data.status,
                        classPlanStudent_id: this.$store.state.modal.data.classPlanStudent_id,
                        class_name: this.$store.state.modal.data.class_name,
                    };
                    this.dialogVisible=true;

                    //创建班级后进入该班
                }
            },
            deleteClassToCart(cart_id, template_time_id) {
                this.$wApi.send('/student/' + this.$student.id, 'delete_cart', {
                    'cart_id': cart_id,
                    'student_id': this.$parentInfo.student.id,
                    'template_time_id': template_time_id
                });
            },
            handleMousedown(evt) {
                if (evt.type == 'class') {
                    this.V4cell.subject_id = evt.subject_id;
                    this.V4cell.teacher_id = evt.teacher_id;
                    this.V4cell.startSort = evt.startSort;
                    this.V4cell.selectable = true;
                } else {
                    this.V4cell.subject_id = evt.subject_id;
                    this.V4cell.teacher_id = evt.teacher_id;
                    this.V4cell.startSort = 0;
                    this.V4cell.selectable = false;
                }
            },
            handleCanvaClick($event) {
                this.cacheData.selectable = true;
            },
            drop: function (evt) {

            },
            allowDrop: function (event) {
                event.preventDefault();
                return true;
            },
            showStudentFuc() {
                this.$refs.V4Table.dropCell.dropClick=false
                if (this.showStudent) {
                    this.$refs['V4Table'].V4rectH = 200 * window.devicePixelRatio;
                    this.$refs['V4Table'].V4divi = 8;

                } else {
                    this.$refs['V4Table'].V4rectH = 50 * window.devicePixelRatio;
                    this.$refs['V4Table'].V4divi = 2;

                }
                this.$nextTick(function () {
                    this.$refs['V4Table'].cell.visible = false;
                    this.$refs.V4Table.initCanvas()
                })
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        }
    }
</script>

<style scoped lang="scss">
    .scell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        width: 100px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }

    .dragging {
        cursor: pointer !important;
    }
</style>
